// extracted by mini-css-extract-plugin
module.exports = {"NewsMainTitle":"style_NewsMainTitle__1GyeC","Title":"style_Title__2XMz6","SubTitle":"style_SubTitle__1XrHX"};